import React from "react";
import "../styles/CollectivePreviewPageTwo.css";

export default function CollectivePreviewPageTwo() {
  return (
    <div className="ttysix-preview-page">
      <div className="ttysix-preview-header">
        <span className="ttysix-preview-header__dots">•••</span>
        <span className="ttysix-preview-header__label">Design Preview 2</span>
      </div>

      <div className="ttysix-preview-canvas">
        <img
          src="/static/img/tmc_page2.png"
          alt="TMC page 2 design preview"
          className="ttysix-preview-image"
        />
      </div>
    </div>
  );
}
